import { useEffect, useState } from 'react';

export default function useLdsModal(isOpenDefault = false) {
  const [isModalOpen, setIsModalOpen] = useState(isOpenDefault);

  const closeModal = () => {
    const htmlTag = document.documentElement;
    const pagePosition = htmlTag.getAttribute('data-modal-position'); // scroll position is set when modal opened

    htmlTag.setAttribute('data-modal-active', 'false');
    htmlTag.style.top = null;
    window.scrollTo(0, pagePosition);

    htmlTag.removeAttribute('data-modal-position');
  };

  const openModal = () => {
    const htmlTag = document.documentElement;
    const pagePosition = htmlTag.scrollTop || window.pageYOffset;

    htmlTag.style.top = `-${pagePosition}px`;
    htmlTag.setAttribute('data-modal-active', 'true');
    htmlTag.setAttribute('data-modal-position', pagePosition);
  };

  useEffect(() => {
    if (isModalOpen) {
      openModal();
    } else {
      closeModal();
    }
  }, [isModalOpen]);

  return {
    isModalOpen,
    setIsModalOpen,
  };
}
